/****************************************************************
 スクロールバーを含めないViewport Width
****************************************************************/
const setVw = function() {
  const vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

/****************************************************************
 予算から選ぶタブ切り替え
****************************************************************/
// 全てのタブボタンとタブコンテンツを取得
const budgetTabButtons = document.querySelectorAll("#budget .tab-button");
const budgetTabContents = document.querySelectorAll("#budget .tab-content");

budgetTabButtons.forEach(button => {
  button.addEventListener("click", () => {
    const targetTab = button.getAttribute("data-tab");

    // 全てのタブボタンからactiveクラスを削除
    budgetTabButtons.forEach(btn => btn.classList.remove("active"));
    // クリックされたボタンにactiveクラスを追加
    button.classList.add("active");

    // 全てのタブコンテンツを非表示
    budgetTabContents.forEach(content => content.classList.remove("active"));
    // 対応するタブコンテンツを表示
    document.getElementById(targetTab).classList.add("active");
  });
});

/****************************************************************
 部位から選ぶタブ切り替え
****************************************************************/
// 全てのタブボタンとタブコンテンツを取得
const BodyPartsTabButtons = document.querySelectorAll("#body-parts .tab-button");
const BodyPartsTabContents = document.querySelectorAll("#body-parts .tab-content");

BodyPartsTabButtons.forEach(button => {
  button.addEventListener("click", () => {
    const targetTab = button.getAttribute("data-tab");

    // 全てのタブボタンからactiveクラスを削除
    BodyPartsTabButtons.forEach(btn => btn.classList.remove("active"));
    // クリックされたボタンにactiveクラスを追加
    button.classList.add("active");

    // 全てのタブコンテンツを非表示
    BodyPartsTabContents.forEach(content => content.classList.remove("active"));
    // 対応するタブコンテンツを表示
    document.getElementById(targetTab).classList.add("active");
  });
});

/****************************************************************
 アンカーリンクスムーススクロール
****************************************************************/
document.addEventListener("DOMContentLoaded", function () {
  // スクロールにかかる時間（速度調整）
  let time = 300; // 800ミリ秒（0.8秒）

  // ページ内リンクのみを取得
  let links = document.querySelectorAll('a[href^="#"]');
  links.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      // 移動先となる要素を取得
      let targetId = this.getAttribute("href").substring(1);
      let target = document.getElementById(targetId);

      if (!target) return;

      // 移動先となる値（ヘッダーの高さを考慮）
      // let headerHeight = document.querySelector("header").offsetHeight;
      let targetY = target.getBoundingClientRect().top + window.scrollY + 4;     

      // スクロールアニメーション
      let startTime;
      function scrollAnimation(currentTime) {
        if (!startTime) startTime = currentTime;
        let elapsedTime = currentTime - startTime;
        let progress = Math.min(elapsedTime / time, 1);

        window.scrollTo(0, window.scrollY + (targetY - window.scrollY) * progress);

        if (progress < 1) {
          requestAnimationFrame(scrollAnimation);
        }
      }

      requestAnimationFrame(scrollAnimation);
    });
  });
});

/****************************************************************
 data-colorからカラーチップの色を読み取る
****************************************************************/
document.querySelectorAll('.item-color').forEach(colorChip => {
  colorChip.style.background = colorChip.getAttribute('data-color');
});

/****************************************************************
 .thumbnailの高さを取得してボタンに適用する関数
****************************************************************/
function adjustSwiperButtonPosition() {
  const thumbnail = document.querySelector('.best-seller_link .thumbnail');
  const prevButton = document.querySelector('.swiper-button-prev');
  const nextButton = document.querySelector('.swiper-button-next');

  if (thumbnail && prevButton && nextButton) {
      const thumbnailHeight = thumbnail.offsetHeight / 2;
      prevButton.style.top = `${thumbnailHeight}px`;
      nextButton.style.top = `${thumbnailHeight}px`;
  }
}

// ページの読み込み後と、ウィンドウのリサイズ時に再計測
window.addEventListener('load', adjustSwiperButtonPosition);
window.addEventListener('resize', adjustSwiperButtonPosition);

/****************************************************************
 テキストの高さを揃える
****************************************************************/
function alignHeights(selector) {
  const items = document.querySelectorAll(selector);
  let maxHeight = 0;

  // 一旦すべての高さをリセット
  items.forEach(item => {
    item.style.height = "auto";
  });

  // 最大の高さを取得
  items.forEach(item => {
    const height = item.getBoundingClientRect().height;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // 最大の高さをすべての要素に適用
  items.forEach(item => {
    item.style.height = `${maxHeight}px`;
  });
}

// 揃える要素を指定
alignHeights("#budget .item-catchcopy");
alignHeights("#budget .item-description");
alignHeights("#body-parts .item-catchcopy");
alignHeights("#body-parts .item-description");
alignHeights("#best-seller .item-catchcopy");
alignHeights("#best-seller .item-description");

// ウィンドウリサイズ時も高さを再計算
window.addEventListener("resize", function () {
  alignHeights("#budget .item-catchcopy");
  alignHeights("#budget .item-description");
  alignHeights("#body-parts .item-catchcopy");
  alignHeights("#body-parts .item-description");
  alignHeights("#best-seller .item-catchcopy");
  alignHeights("#best-seller .item-description");
});